<template>
  <!-- 会员中心-互助会员 -->
  <div>
    <div class="activeType">
      <div v-if="create_icon == 1">
        <div class="activeType_top">
          <div class="content-left">
            <img
              :src="activityData.bghome"
              style="width: 93%;top: 50%;
              position: absolute;
              left: 50%;
              transform: translate(-50%, -50%);"
              alt=""
            />
          </div>
          <div class="content-right">
            <div class="sign">{{ activityData.title }}<span class="sign_jc pointer" @click="handleWord()">使用教程</span></div>
            <span class="sign_desc">{{ activityData.content }}</span>
            <div class="QRcode">
              <div class="card-point tipBg">
                <div class="card-rule" style="width: 45px;">注：</div>
                <div class="card-connet">
                  <p>
                    1、一个店铺同一时间只能有一个活动放到APP首页的悬浮图标上
                  </p>
                  <p>2、根据京东规则，悬浮图标有效期只能在3～31天，悬浮图标开启后，显示会有5～20分钟左右的延迟</p>
                </div>
              </div>
              <!-- <div class="QRcode_img" id="QRcode_img" ref="QRcode_img"></div>
              <span>京东APP扫码预览</span> -->
              <div class="QRcode_btn pointer" @click="activeShow({}, 'add')">
                创建活动
              </div>
            </div>
          </div>
        </div>

        <!-- 头部查询表单 -->
        <!-- <div class="headForm">
          <div class="head">
            <div style="overflow:hidden">
              <div style="margin-bottom:20px">
                悬浮图标
              </div>
              <div>
                <div class="imgBox" style="float:left">
                  <img :src="floatingicon" alt="" />
                </div>
                <div style="float:left;margin-left:50px;width:calc(100% - 300px)">
                  <h2>悬浮图标管理</h2>
                  <div style="font-weight:400;font-size:14px;margin-top:10px;line-height:18px;color:#979797;">
                    悬浮图标是指在手机京东APP店铺首页出现悬浮的图标，买家点击图标参与店铺互动活动，图标多种多样可以<br />
                    任意选择，也支持自己上传，魔性的小图标让无线运营变的简单有效，增加店铺关注量，提升店铺粘性。
                  </div>
                  <div
                    class="tipBg"
                    style="font-weight:400;font-size:12px;margin-top:10px;line-height:18px;background-color:#fffaee;width:670px;padding:5px 10px;color:#979797;"
                  >
                    <i class="el-icon-info" style="color:#7b61ff"></i>
                    注意: 1、一个店铺同一时间只能有一个活动放到APP首页的悬浮图标上；<br /><span style="margin-left:45px"
                      >2、由于京东缓存活动开启5-10分钟后，县浮图标才会在店铺首页显示。</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <el-button type="primary" style="transform:translate(46px,10px)" @click="activeShow({}, 'add')" icon="el-icon-circle-plus"
              >创建</el-button
            >
          </div>
          
        </div> -->
        <div class="input-form-box">
          <input-form ref="inputForm" style="margin: 40px 0" :inputData="inputData" :btnPosition1="true" @toParentVal="searchContent"></input-form>
        </div>
        <div style="color: red;padding-bottom:15px;">
          预创建的店铺悬浮图标非100%创建成功，当创建的图标生效时间与其他悬浮图标生效时间重叠时，则会出现创建失败情况，请注意避免此状况发生。
        </div>
        <div class="content">
          <el-table
            :data="tableData"
            v-loading="talbeLoading"
            style="width: 100%; margintop: 20px"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <el-table-column prop="name" label="活动名称"></el-table-column>
            <el-table-column prop="date" label="悬浮图标">
              <template slot-scope="scope">
                <img :src="scope.row.imageUrl" style="width:50px;height:50px" />
              </template>
            </el-table-column>
            <el-table-column prop="date" label="活动时间">
              <template slot-scope="scope">
                <div>起：{{ scope.row.beginTime }}</div>
                <div>止：{{ scope.row.endTime }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="活动状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == -1">已关闭</span>
                <span v-if="scope.row.status == 1">未开始</span>
                <span v-if="scope.row.status == 2">进行中</span>
                <span v-if="scope.row.status == 3">已结束</span>
                <span v-if="scope.row.status == 4"> 创建失败 </span>
                <el-tooltip
                  v-if="scope.row.status == 4"
                  effect="dark"
                  :content="scope.row.failReason"
                  placement="top-start"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="date" label="操作" width="200px">
              <template slot-scope="scope">
                <span style="cursor:pointer;margin-right:12px;color:#7B61FF" @click="activeShow(scope.row, 'look')">查看</span>
                <span
                  v-if="scope.row.status == 1 || scope.row.status == 2"
                  style="cursor:pointer;margin-right:12px;color:#7B61FF"
                  @click="activeShow(scope.row, 'edit')"
                  >编辑</span
                >
                <span style="cursor:pointer;margin-right:12px;color:#7B61FF" @click="onshare(scope.row)">分享</span>
                <span v-if="scope.row.status == 1 || scope.row.status == 2" style="cursor:pointer;color:#7B61FF" @click="delIsvActivity(scope.row.id)"
                  >关闭活动</span
                >
                <span style="cursor:pointer;margin-right:12px;color:#7B61FF" @click="deleteActivity(scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 20px; text-align: right; margin-bottom: 20px">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="formData.current"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="formData.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              style="text-align: right; margin-top: 20px"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="content" v-if="create_icon == 2" style="height:calc(100vh - 132px);position:relative">
        <div class="chartBox chartBox2" style="padding-bottom: 10px">
          <div class="headReturn">
            <span @click="create_icon = 1" style="cursor:pointer"> <i class="iconfont iconicon_fanhui"></i> 返回</span>
            <span style="margin: 0 20px">|</span>
            <span class="name" v-show="showEdit == 1">创建悬浮图标</span>
            <span class="name" v-show="showEdit == 2">编辑悬浮图标</span>
            <span class="name" v-show="showEdit == 3">查看悬浮图标</span>
          </div>
          <div style="margin:20px;padding:32px 0 0 4px;">
            <el-form :model="createform" label-width="100px">
              <el-form-item label="活动名称" required>
                <el-input
                  v-model="createform.name"
                  maxlength="15"
                  show-word-limit
                  style="width:400px"
                  :disabled="createType == 'look'"
                  placeholder="请输入活动名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="活动时间" required>
                <el-date-picker
                  style="width:400px"
                  @input="$forceUpdate()"
                  :disabled="createType == 'look'"
                  v-model="createform.time"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="changeTime"
                  :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
                <span style="margin-left:10px">
                  活动持续<span style="color:#ff0000;margin:0 5px">{{ activityDays }}</span
                  >天<span style="color:#ff0000;margin:0 5px">{{ activityHours }}</span
                  >小时
                  <el-tooltip class="item" effect="dark" content="活动有效期不可超过订购有效期" placement="top-start">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </span>
              </el-form-item>
              <!-- <el-form-item label="活动类型" required>
                <el-select v-model="createform.note" placeholder="请选择" :disabled="createType == 'look'">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="跳转链接" required>
                <el-input v-model="createform.isvUrl" style="width:400px" :disabled="createType == 'look'"></el-input>
              </el-form-item>
              <el-form-item label="" required>
                <div style="margin-top:-20px;color:#696b6f;display: flex;">
                  <img
                    src="@/assets/images/new_icon_reminder1.png"
                    style="
                      display: inline-block;
                      width: 14px;
                      height: 14px;
                      color: #ffffff;
                      margin: 9px 4px 0 3px;
                    "
                  />
                  注意：自定义跳转链接必须为京东域内链接
                </div>
              </el-form-item>
              <el-form-item label="悬浮图标:" class="floating_upload" required>
                <div class="floating_img1" style="border: 1px soild #f0f0f0;display:inline-block">
                  <img :src="createform.imageUrl" v-if="createform.imageUrl" style="width:50px;height:50px;margin-right:10px" />
                  <!-- <div v-if="createform.imageUrl.length == 0" style="width:50px;height:50px;background-color:#eaeaec"></div> -->
                </div>
                <el-button class="status_btn3" @click="onSelecticon" style="position:absolute;top:0px;" v-if="createType != 'look'"
                  >选择图标
                </el-button>
              </el-form-item>
              <el-form-item style="text-align:center;position:absolute;bottom:20px;left:50%;transform:translateX(-50%)">
                <el-button type="primary" @click="handleAdd" v-if="createType == 'add'">立即创建</el-button>
                <el-button type="primary" @click="handleEdit" v-if="createType == 'edit'">立即修改</el-button>
                <el-button @click="create_icon = 1">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- 分享 -->
      <el-dialog title="分享" top="20vh" :visible.sync="dialogshareVisible" :show-close="true" :before-close="qrcodeReset" width="584px">
        <div class="share">
          <span style="margin-left: 118px">请打开京东APP扫描下面二维码预览当前活动</span>
          <div class="sharecode" style="margin: 20px auto;margin-left: 156px;">
            <!-- <img :src="'data:image/jpeg;base64,' + qrCode" /> -->
            <div class="qrcode" id="qrcode" ref="qrcode"></div>
          </div>
          <div class="sharefooter">
            <span>访问链接:</span>
            <el-input readonly prop="shareurl" v-model="idUrl" style="width: 382px"></el-input>
            <el-button class="status_btn3" size="small" @click="CopyUrl1" style="margin-left: 10px; width: 90px">复制链接 </el-button>
          </div>
        </div>
      </el-dialog>
      <image-manage :dialoguploadVisible="dialoguploadVisible" @on-close="dialoguploadVisible = false" @on-confirm="onConfirm"></image-manage>
    </div>
    <el-dialog title="提示" :visible.sync="outerVisibleTwo" width="400px" :before-close="closehandleDeleteTwo"
      ><img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
          margin: 6px 0px 0px 110px;
          position: absolute;
          width: 22px;
          height: 22px;
        "
      />
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">是否删除活动？</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDeleteTwo">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTableTwo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import inputForm from "../../components/inputForm";
import imageManage from "./image_manage";
import {
  getIsvActivityList,
  addIsvActivity,
  delIsvActivity,
  editIsvActivity,
  getActivityIdByType,
  deleteActivity,
} from "../../api/integralCenter/suspensionDiagram";
import { prefixurl } from "@/api/paradiseAndTaskCommonController.js";
export default {
  name: "",
  data() {
    return {
      activityData: {
        bghome: require("@/assets/thdImg/active/xft.png"),
        title: "店铺首页悬浮图标",
        content:
          "悬浮图标是指在手机京东APP店铺首页出现悬浮的图标，买家点击图标参与店铺互动活动，图标多种多样可以任意选择，也支持自己上传，魔性的小图标让无线运营变的简单有效，增加店铺关注量，提升店铺粘性",
      },
      status: 1,
      ids: "",
      outerVisibleTwo: false,
      floatingicon: require("../../assets/images/入口2.png"), //悬浮图标图片
      // pageName: "忠诚度管理-互动会员",
      inputData: [
        {
          name: "活动名称:",
          val: "name",
          placeholder: "请输入",
        },
        // {
        //   name: "活动类型:",
        //   val: "note",
        //   placeholder: "请选择",
        //   selectArr: [
        //     { label: "全部", id: "" },
        //     { label: "日历签到", id: "1" },
        //     { label: "浏览商品有礼", id: "2" },
        //     { label: "每日抢好礼", id: "3" },
        //     { label: "关注店铺有礼", id: "4" },
        //     { label: "邀请开卡有礼", id: "5" },
        //     { label: "邀请关注店铺", id: "6" },
        //     { label: "完善信息有礼", id: "7" },
        //     // { label: "爆品优惠券", id: '1' },
        //     // { label: "抽奖", id: '2' },
        //     // { label: "其他", id: '3' },
        //   ],
        // },
        {
          name: "活动状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "--全部--", id: "" },
            { label: "已关闭", id: -1 },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "创建失败", id: 4 },
            // { label: "已完成", id: 3 },
            // { label: "已暂停", id: 4 },
          ],
        },
        {
          name: "有效期:",
          myDate: true,
          val: ["beginTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: false,
        },
      ],
      create_icon: 1,
      showEdit: 1,
      dialoguploadVisible: false,
      dialogshareVisible: false,
      talbeLoading: false,
      tableData: [],
      formData: {
        current: 1,
        size: 10,
      },
      total: 10,
      qrCode: "", //活动二维码
      releaseurl: "", //发布链接
      shareurl: "", //分享链接
      //
      options: [
        { label: "其他", value: "0" },
        { label: "日历签到", value: "1" },
        { label: "浏览商品有礼", value: "2" },
        { label: "每日抢好礼", value: "3" },
        { label: "关注店铺有礼", value: "4" },
        { label: "邀请开卡有礼", value: "5" },
        { label: "邀请关注店铺", value: "6" },
        { label: "完善信息有礼", value: "7" },
      ],
      createform: {
        time: "",
        note: "0",
        name: "",
        isvUrl: "",
        imageUrl: "",
      },
      createType: "add",
      activityUrl: "",
      venderId: "",
      idUrl: "",
      activityDays: 0,
      activityHours: 0,
      // createform:{}
    };
  },
  methods: {
    handleWord() {
      window.open("https://www.yuque.com/yunduanxincrm/flgan6/sy90ng2zbi68va09", "_blank");
    },
    // 生成二维码
    getCodeIMG() {
      // const url = this.activityData.codeUrl;
      if (this.$refs.QRcode_img) {
        this.$refs.QRcode_img.innerHTML = "";
        new QRCode("QRcode_img", {
          errorCorrectionLevel: "H", //容错级别 L M Q H
          width: 134, // 设置宽度，单位像素
          height: 134, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=https://jdminiapp.yucrm.cn/html/images/Preview/xuanfu.png`,
        });
      }
    },
    getList() {
      this.talbeLoading = true;
      getIsvActivityList(this.formData).then((res) => {
        this.tableData = res.data.records;
        this.total = Number(res.data.total);
        this.talbeLoading = false;
      });
    },
    prefixQue() {
      prefixurl()
        .then((res) => {
          this.activityUrl = res.data.activityUrl;
          this.venderId = res.data.venderId;
        })
        .catch((res) => {});
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 200, // 设置宽度，单位像素
        height: 200, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
      console.log(this.qrcode);
    },
    onshare(item) {
      this.dialogshareVisible = true;
      this.qrCode = "";
      // this.$refs.qrcode.innerHTML = "";
      let mesUrl = "";
      if (item.note == 1) {
        mesUrl = "sign_polite"; //日历签到
      } else if (item.note == 2) {
        mesUrl = "sign_polite"; // 浏览礼品有礼
      } else if (item.note == 3) {
        mesUrl = "rob_goodPresent"; //每日抢好礼
      } else if (item.note == 4) {
        mesUrl = "attention_shop"; //关注店铺有礼
      } else if (item.note == 5) {
        mesUrl = "invitationopenCard"; //邀请开卡
      } else if (item.note == 6) {
        mesUrl = "invitationattention"; //邀请关注店铺
      } else if (item.note == 7) {
        mesUrl = "perfect_information"; //完善信息
      } else if (item.note == 8) {
        mesUrl = "lottery_turntable"; //幸运抽奖
      }
      // this.idUrl = this.activityUrl + "/" + mesUrl + "?activityId=" + item.id + "&venderId=" + this.venderId;
      this.idUrl = "http://index.yeionsms.com/yidongd/index2.html?image=" + encodeURI(item.imageUrl);
      // this.onrqCode(url);
      this.$nextTick(() => {
        let queryId = "qrcode";
        this.qrcodeAll(this.idUrl, queryId);
      });
    },
    qrcodeReset() {
      this.dialogshareVisible = false;
      this.$refs.qrcode.innerHTML = "";
    },
    //链接转二维码
    // onrqCode(url) {
    //   let content = url;
    //   rqCode({ content: content })
    //     .then((res) => {
    //       this.qrCode = res.data;
    //       console.log(this.qrCode);
    //     })
    //     .catch((res) => {
    //       this.$message.error(res.message);
    //     });
    // },
    CopyUrl1() {
      var Url2 = this.idUrl;
      var oInput = document.createElement("input");
      oInput.value = Url2;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      this.$message({
        message: "复制成功!",
        type: "success",
      });
    },
    onConfirm(item) {
      this.dialoguploadVisible = false;
      this.createform.imageUrl = item.imageUrl;
      if (item.id) {
        this.createform.templateId = item.id;
      } else {
        this.createform.templateId = null;
      }
    },
    searchContent(item) {
      this.formData.beginTime = item.beginTime;
      this.formData.endTime = item.endTime;
      this.formData.name = item.name;
      this.formData.note = item.note;
      this.formData.status = item.status;
      this.formData.current = 1;
      this.getList();
    },
    handleSizeChange(size) {
      this.formData.size = size;
      this.getList();
    },
    handleCurrentChange(current) {
      this.formData.current = current;
      this.getList();
    },
    changeTime(val) {
      if (val) {
        var difftime = (new Date(val[1]) - new Date(val[0])) / 1000;
        this.activityDays = parseInt(difftime / 86400);
        this.activityHours = parseInt(difftime / 3600) - 24 * this.activityDays;
      }
    },
    //
    onSelecticon() {
      this.dialoguploadVisible = true;
      // this.uploadform.src = "";
      // this.table = 1;
      // this.gallerytype = 1;
      // this.active = -1;
    },
    handleAdd() {
      this.createform.beginTime = this.createform.time;
      var obj = {
        beginTime: this.createform.time[0],
        endTime: this.createform.time[1],
        name: this.createform.name,
        note: this.createform.note,
        isvUrl: this.createform.isvUrl,
        imageUrl: this.createform.imageUrl,
        templateId: this.createform.templateId,
      };
      addIsvActivity(obj).then((res) => {
        if (res.code == 0) {
          this.$message({ message: res.message, type: "warning" });
        } else {
          this.$message({ message: res.message, type: "type" });
          this.create_icon = 1;
          this.getList();
          this.getCodeIMG();
        }
      });
    },
    handleEdit() {
      var obj = {
        beginTime: this.createform.time[0],
        endTime: this.createform.time[1],
        name: this.createform.name,
        note: this.createform.note,
        isvUrl: this.createform.isvUrl,
        imageUrl: this.createform.imageUrl,
        id: this.createform.id,
        templateId: this.createform.templateId,
      };
      editIsvActivity(obj).then((res) => {
        if (res.data.code == 0) {
          this.$message({ message: res.data.message, type: "warning" });
        } else {
          this.$message({ message: res.message, type: "success" });
          this.create_icon = 1;
          this.getList();
          this.getCodeIMG();
        }
      });
    },
    //
    activeShow(item, type) {
      this.createType = type;
      this.create_icon = 2;
      if (type == "add") {
        this.createform.name = "";
        this.createform.note = "0";
        this.createform.isvUrl = "";
        this.createform.imageUrl = "";
        this.createform.time = [this.moment().add(10,'m').format('YYYY-MM-DD HH:mm:ss'), this.getDay(30, "-") + " 23:59:59"];
        this.createform.beginTime = "";
        this.createform.endTime = "";
        this.showEdit = 1;
        this.activityDays = 30;
        this.activityHours = 23;
      } else {
        this.createform = JSON.parse(JSON.stringify(item));
        this.createform.time = [];
        // this.createform.time[0] = item.beginTime;
        // 新建和修改的规则一致（当前时间+10分钟）
        this.createform.time[0] = this.moment().add(10,'m').format('YYYY-MM-DD HH:mm:ss');
        this.createform.time[1] = item.endTime;
        this.changeTime(this.createform.time);
      }
      if (type == "edit") {
        this.showEdit = 2;
      } else if (type == "look") {
        this.showEdit = 3;
      }
    },
    //关闭活动
    delIsvActivity(id) {
      this.$confirm("活动关闭后将不能再开启，是否确认关闭?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delIsvActivity({ id: id }).then((res) => {
            this.$message({ message: "关闭成功", type: "success" });
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    closehandleDeleteTwo() {
      this.outerVisibleTwo = false;
    },
    //删除活动
    deleteActivity(id) {
      this.status = id.status;
      this.outerVisibleTwo = true;
      this.ids = id.id;
    },
    // 删除
    handleDeleteTableTwo() {
      if (this.status == 2 || this.status == 1) {
        this.$message.error("先结束活动再进行删除");
        this.outerVisibleTwo = false;
      } else {
        let id = this.ids;
        deleteActivity(id)
          .then((res) => {
            if (res && res.code == 1) {
              this.$message.success("删除成功");
              this.outerVisibleTwo = false;
              this.getList();
            }
          })
          .catch(() => {
            this.$message.error("删除失败");
          });
      }
    },
  },
  mounted() {
    this.getList();
    this.prefixQue();
    this.getCodeIMG();
    // getActivityIdByType().then(res=>{
    //   console.log(res,'res')
    // })
  },
  components: {
    inputForm,
    imageManage,
  },
};
</script>

<style scoped lang="scss">
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}
.activeType {
  // width: 98%;
  margin: 24px;
  padding: 24px;
  // min-height: 1062px;
  background: #ffffff;
  padding-bottom: 0;
  min-height: 88vh;
  &_top {
    display: flex;
    .content-left {
      width: 184px;
      height: 336px;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
      border-radius: 12px 12px 12px 12px;
      border: 1px solid #ffffff;
      margin-bottom: 40px;
      overflow: hidden;
      position: relative;
    }
    .content-right {
      flex: 1;
      margin-left: 33px;
      margin-top: 16px;
    }
    .sign {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      margin-bottom: 12px;
      display: flex;
      align-items: end;
      &_jc {
        font-size: 14px;
        color: #999999;
        margin-left: 20px;
        display: flex;
        &::before {
          content: "";
          width: 15px;
          height: 15px;
          margin-right: 4px;
          background: url("../../assets/thdImg/pages/question.svg") no-repeat;
        }
      }
    }
    .sign_desc {
      font-size: 14px;
      color: #666666;
    }
    .QRcode {
      // width: 150px;
      height: 170px;
      display: flex;
      flex-wrap: wrap;
      // align-items: center;
      // justify-content: center;
      font-size: 12px;
      color: #000000;
      // margin-top: 50px;
      &_img {
        width: 100%;
        height: 150px;
        // background: #7b61ff;
        box-shadow: 0px 4px 20px 1px rgba(18, 10, 60, 0.15);
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #ffffff;
        margin-bottom: 10px;
        box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
        border-radius: 12px 12px 12px 12px;
        padding: 7px;
      }
      &_btn {
        width: 96px;
        height: 32px;
        // line-height: 32px;
        // text-align: center;
        background: #7b61ff;
        border-radius: 4px 4px 4px 4px;
        margin-top: 24px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        &::before {
          content: "";
          width: 19px;
          height: 19px;
          margin-right: 5px;
          background: url("../../assets/thdImg/pages/create.svg") no-repeat;
        }
      }
    }
  }
  .tabSwitch {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    // padding: 0 20px;
    position: relative;
    height: 50px;
    font-size: 14px;
    color: #666;
    border-bottom: 1px solid #f6f6f6;
    &-wz {
      height: 50px;
      line-height: 50px;
      position: relative;
      margin-right: 24px;
      cursor: pointer;
      transition: all 0.2s;
    }
    .active {
      color: #7b61ff;
      &::before {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 100%;
        height: 2px;
        background-color: #7b61ff;
        transition: all 0.2s;
        animation: opation 0.2s;
      }
      @keyframes opation {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 100%;
        }
      }
    }
  }
  .formClass {
    margin: 24px 0;
    display: flex;
    /deep/.el-form-item {
      margin-right: 50px;
    }
    .seach_btn {
      margin-left: auto;
      margin-right: 30px;
      display: flex;
    }
    .search,
    .reset {
      width: 98px;
      font-size: 14px;
      height: 32px;
      transition: all 0.2s;
      border-radius: 4px 4px 4px 4px;
    }
    .search {
      color: #fff;
      background-color: #7b61ff;
      &:hover {
        opacity: 0.8;
      }
    }
    .reset {
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #7b61ff;
        border: 1px solid #7b61ff;
        background: rgba(38, 112, 251, 0.1);
      }
    }
  }
  &_bottom {
    padding-bottom: 24px;
    .template {
      display: flex;
      color: #333333;
      // align-items: center;
      margin-bottom: 16px;
      &-nav {
        display: flex;
        flex-wrap: wrap;
      }
      &-wz {
        padding: 4px 8px;
        color: #666666;
        background: #f8f8fb;
        border-radius: 4px;
        margin-left: 12px;
        margin-bottom: 10px;
        &:hover {
          background: #7b61ff;
          border-radius: 4px;
          color: #ffffff;
        }
      }
      .activeTem {
        background: #7b61ff;
        border-radius: 4px;
        color: #ffffff;
      }
    }
    .templateBox {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    }
    .temImg {
      width: 224px;
      height: 453px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-right: 41px;
      &:hover .temImg_content_bgshadow {
        opacity: 0;
        animation: key3 0.5s forwards;
      }
      @keyframes key3 {
        0% {
          opacity: 0;
        }
        50% {
          opacity: 0.3;
        }
        100% {
          opacity: 1;
        }
      }
      .temImg_content_bgshadow {
        z-index: 123;
        opacity: 0;
        position: absolute;
        // left: -1;
        top: 10px;
        width: 100%;
        height: 380px;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 8px 8px 0px 0px;
        transform: scale(1.05);
        &_code {
          margin: 0 auto;
          margin-top: 125px;
          width: 150px;
          height: 150px;
          background: #ffffff;
          border-radius: 4px;
          padding: 5px;
        }
        &_codeDesc {
          margin: 0 auto;
          margin-top: 15px;
          width: 112px;
          color: #ffffff;
        }
        &_btn {
          margin: 0 auto;
          margin-top: 25px;
          width: 86px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          background: #7b61ff;
          border-radius: 4px;
          color: #ffffff;
        }
        &_jx {
          margin-top: 9px;
          color: #fff;
          text-align: center;
          line-height: 18px;
          opacity: 0.7;
        }
      }
      &_content {
        width: 100%;
        height: 433px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        transition: 0.6s linear;
        &_img {
          width: 100%;
          height: 380px;
          border-radius: 8px 8px 0px 0px;
          // background: #666;
          background: rgba(38, 112, 251, 0.05);
          // transition: 0.6s linear;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &_wz {
          width: 100%;
          height: 53px;
          padding: 10px 12px;
        }
      }

      &:hover {
        .temImg_content {
          box-shadow: 0px 12px 25px 1px rgba(0, 0, 0, 0.15);
          border-radius: 8px;
          transform: scale(1.05);
          transition: transform 0.3s, -webkit-transform 0.3s;
        }
      }
      &_dz {
        width: 100%;
        // height: 433px;
        display: flex;
        justify-content: center;
        align-items: center;
        &_center {
          > img {
            margin: 0 auto;
            display: block;
          }
          > span {
            font-size: 20px;
            font-weight: bold;
            margin-top: 12px;
            display: block;
          }
        }
      }
      &_title {
        display: block;
        color: #333333;
      }
      &_desc {
        display: block;
        font-size: 12px;
        line-height: 23px;
        color: #999;
      }
    }
    @media screen and (min-width: 1350px) and (max-width: 1700px) {
      .temImg {
        margin-right: 26px !important;
      }
    }
  }
}
</style>
